import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { formatDisplayDateTime } from 'src/helpers/date.helpers';
import type { ScheduledTask } from '../types/scheduler.types';
import { SchedulerDsButton } from './scheduler-ds-button';

interface SchedulerRunNowDialogProps {
  task: ScheduledTask | null;
  open: boolean;
  isRunning?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
}

export function SchedulerRunNowDialog({
  task,
  open,
  isRunning = false,
  onOpenChange,
  onConfirm,
}: SchedulerRunNowDialogProps) {
  const nextRunLabel = task?.next_run_at
    ? formatDisplayDateTime(task.next_run_at)
    : 'not scheduled';

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        className="bg-white sm:max-w-md"
        onClick={(event) => event.stopPropagation()}
      >
        <DialogHeader>
          <DialogTitle>
            Run task now?
          </DialogTitle>
          <DialogDescription>
            {task
              ? `Run "${task.name}" now? This will enqueue an extra run without changing the next scheduled run at ${nextRunLabel}.`
              : 'This will enqueue an extra run without changing the next scheduled run.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <SchedulerDsButton
            type="button"
            variant="secondary"
            disabled={isRunning}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </SchedulerDsButton>
          <SchedulerDsButton
            type="button"
            variant="accent"
            disabled={isRunning}
            onClick={() => void onConfirm()}
          >
            Run Now
          </SchedulerDsButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
